import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import './App.css';
import axios from 'axios';
import Map from './js/Map';
import Store from './js/Store';
import data from './js/extra-data';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

// The Store Locator app.
class TkStoreLocator extends Component {

	static defaultProps = {
		stateLocations: data['stateLocationsData'],
	}

	constructor(props) {
		super(props);

		this.state = {
			environment		: 'dev',
			storeData     	: data['storeDataLocal'].Stores,
			activeStores   	: data['storeDataLocal'].Stores,
			outputClass   	: '',
			paragraphs    	: 3,
			length      	: 3,
			googleMapsAPI 	: data['googleMapsAPIDefault'],
			mapStyle		: data['mapStyleLocal']
		}

		this.setEnvironment = this.setEnvironment.bind(this);
		this.getActiveStores = this.getActiveStores.bind(this);
		this._showAllStores = this._showAllStores.bind(this);
	}

	componentDidMount() {
		this.setEnvironment();
	}

	// Are we in dev or production?
	setEnvironment() {

		// 'dev' is the react environment
		// 'local' is running docker WP locally
		// 'production' is production
		const theEnv = ReactDOM.findDOMNode( this ).parentNode.getAttribute( "data-env" );

		this.setState({ environment : theEnv }, function () {
			this.getStores();
			this.getSettings();
		});


	}

	getSettings() {
		var _this = this;

		if ( this.state.environment !== 'dev' ) {

			let form_data = new FormData();
			form_data.append( 'action', 'tk_store_get_settings' );

			axios.post( '/wp-admin/admin-ajax.php', form_data ).then( function( response ) {

				_this.setState( {
					googleMapsAPI: response.data.googleMapsAPIKey,
					mapStyle: JSON.parse( response.data.snazzymaps )
				} );

			} )

		}

	}

	// Array sorting tool.
	sortStores( a, b ) {
		if ( a.Name < b.Name ) {
			return -1;
		}

		if ( a.Name > b.Name ) {
			return 1;
		}

		return 0;
	}

	getStores() {

		if ( this.state.environment === 'production' ) {
			var _this = this;

			// Getting store data from JSON file.
			axios.get( '/wp-content/uploads/store-data.json' )
				.then( function( result ) {

					var stores = result.data.Stores;

					stores.sort( _this.sortStores );

					_this.setState( { storeData: stores } );

				} 
			);

		}

	}

	// Update list of stores.
	getActiveStores( val ){

		val.sort( this.sortStores );

		this.setState( { 
			activeStores : val
		}); 
	}


	// Show all stores.
	_showAllStores(){

		const allStores = this.state.storeData; 

		allStores.sort( this.sortStores );

		this.setState( { 
			activeStores : allStores
		}); 
	}


	render() {

		let storeMsg = null;

		if ( ! this.state.activeStores.length ) {
			storeMsg = 'Sorry, there aren\'t any stores here. Try another search.';
		}


	    return (
			<div className="tk-store-locator">
				<Map 
					data={ this.state.storeData } 
					startLoc={ this.props.stateLocations.Washington } 
					mapStyle={ this.state.mapStyle } 
					sendActiveStores={this.getActiveStores} />

					<p><button className="tk-store-locator__show-all btn btn-primary btn--alt" onClick={ this._showAllStores } >Show all locations</button></p>

					<ReactCSSTransitionGroup 
						component="ul" 
						className="tk-store-locator__list" 
						transitionName="tk-store-locator--fade"
						transitionEnterTimeout={150}
						transitionLeaveTimeout={150} >
					{
						Object
						.keys(this.state.activeStores)
						.map(key => <Store 
										key={key} 
										index={key} 
										data={this.state.activeStores[key]} />
							)
					}
					</ReactCSSTransitionGroup>

					<p className="tk-store-locator__store-msg">{storeMsg}</p>

			</div>
		);
	}

}

export default TkStoreLocator;



// WEBPACK FOOTER //
// ./src/App.js